<template>
  <div>
    <!-- textarea -->
    <div v-if="question.type === 'textarea' || question.type === 'follow-textarea'" :class="containerClass">
      <div class="w-full">
        <div class="py-2" v-html="question.title"></div>
        <div class="py-2" >
          <textarea-input  v-model="question.result" :placeholder="question.options? question.options.placeholder: 'Please input here...'" :class-name="inputClass"
                           :error="(question.result===null||question.result==='') && question.mandatory && showMandatory? 'required' : null">
          </textarea-input>
        </div>
      </div>
    </div>

    <!-- Grouped textareas with radio options -->
    <div v-if="question.type === 'textareas-with-radio'" :class="containerClass">
      <div class="w-full">
        <div class="py-2" v-html="question.title"></div>
        <div class="flex" v-for="i in question.options.count" :key="i">
          <div class="py-2 mr-4" :class="question.options.radio? 'w-4/5' : 'w-full'">
            <textarea-input :rows="3"  v-model="question.result[i].text" :placeholder="question.options? question.options.placeholder: 'Please input here...'" :class-name="inputClass"
                            :error="(question.result===null||question.result==='') && question.mandatory && showMandatory? 'required' : null">
            </textarea-input>
          </div>
          <div class="w-1/5 py-2" v-if="question.options.radio">
            <div class="flex items-center justify-between">
              <div class="flex pr-4" :class="inputClass">
                <input type="radio" v-model="question.result[i]['radio']" :id="question.id+'_radio_agent_'+i" :name="question.id+'radio_' + i" value="agent" style="width:50px; height: 20px;">
                <label :for="question.id+'_radio_agent_'+i" class="ml-4 mt-2">Agent</label>
              </div>
              <div class="flex pr-4" :class="inputClass">
                <input type="radio" v-model="question.result[i]['radio']" :id="question.id+'_radio_guild_'+i" :name="question.id+'radio_' + i" value="guild" style="width:50px; height: 20px;">
                <label :for="question.id+'_radio_guild_'+i" class="ml-4 mt-2">Guild</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- input -->
    <div v-if="question.type === 'input'" :class="containerClass">
      <div class="py-2 flex-grow max-w-screen-md" v-html="question.title"></div>
      <div v-if="question.compare_last_year_flag" :class="columnClass" class="border-l border-r px-4 mr-2 items-center">
        <span v-if="question.options && question.options.prefix" class="mr-2">{{question.options.prefix}}</span>
        <text-input  :value="question.previous_value" class-name="mb-0" disabled></text-input>
        <span v-if="question.options && question.options.postfix" class="ml-2">{{question.options.postfix}}</span>
      </div>
      <div class="w-1/6 px-4 flex justify-end items-center">
        <span v-if="question.options && question.options.prefix" class="mr-2">{{question.options.prefix}}</span>
        <text-input  v-model="question.result" class-name="mb-0" :error="(question.result===null||question.result==='') && question.mandatory && showMandatory? 'required' : null"></text-input>
        <span v-if="question.options && question.options.postfix" class="ml-2">{{question.options.postfix}}</span>
      </div>
    </div>

    <!-- inputs -->
    <div v-if="question.type === 'inputs' && question.options && question.options.inputs" :class="containerClass">
      <div class="py-2 flex-grow max-w-screen-md" v-html="question.title"></div>
      <div v-for="(previousItem, previousIndex) in question.options.inputs" :key="'previousIndex' + previousIndex" v-if="question.compare_last_year_flag && question.options.previous.includes(previousIndex)" :class="columnClass" class="border-l border-r px-4 mr-2 items-center">
        <span class="mr-2">Previous</span>
        <span v-if="question.options.inputs && question.options.inputs[previousIndex].prefix" class="mr-2">{{question.options.inputs[previousIndex].prefix}}</span>
        <text-input  v-model="question.previous_value[previousItem.id]" class-name="mb-0" disabled></text-input>
        <span v-if="question.options.inputs && question.options.inputs[previousIndex].postfix" class="ml-2">{{question.options.inputs[previousIndex].postfix}}</span>
      </div>
      <div v-for="(item, itemIndex) in question.options.inputs" :key="itemIndex" :class="columnClass">
        <span class="mr-2">{{item.name}}</span>
        <span v-if="item.prefix" class="mr-2">{{item.prefix}}</span>
        <text-input  v-model="question.result[item.id]" class-name="items-center mb-0'"
                     :error="(question.result===null||question.result==='') && question.mandatory && showMandatory? 'required' : null"></text-input>
        <span v-if="item.postfix" class="ml-2">{{item.postfix}}</span>
      </div>
    </div>

    <!-- half input -->
    <div v-if="question.type === 'half-input'" class="w-full pr-8">
      <div class="py-2 max-w-screen-md" v-html="question.title"></div>
      <div class="flex items-center">
        <span v-if="question.options && question.options.prefix" class="mr-2">{{question.options.prefix}}</span>
        <text-input  v-model="question.result" class-name="mb-0 w-full" :placeholder="question.options && question.options.placeholder? question.options.placeholder : ''"
                     :error="(question.result===null||question.result==='') && question.mandatory && showMandatory? 'required' : null"></text-input>
        <span v-if="question.options && question.options.postfix" class="ml-2">{{question.options.postfix}}</span>
      </div>
    </div>

    <!-- radio -->
    <div v-if="question.type === 'radio' && question.options && question.options.radios" :class="containerClass">
      <div class="py-2 flex-grow max-w-screen-md" v-html="question.title" ></div>
      <div v-if="question.compare_last_year_flag" :class="columnClass" class="border-l border-r pr-4 mr-2 items-center">
        <div v-if="question.previous_value" class="text-green-600 w-full text-center items-center" :class="inputClass">YES</div>
        <div v-else-if="question.previous_value!==null" :class="inputClass" class="w-full text-center">NO</div>
        <div v-else :class="inputClass" class="w-full text-center">N/A</div>
      </div>
      <div :class="columnClass" class="items-center">
        <div class="w-full">
          <div class="flex items-center justify-between">
            <div v-for="(radioItem, i) in question.options.radios" :key="i" class="pr-4" :class="inputClass">
              <input type="radio" :id="question.id+'_radio_'+i" :name="question.id+'radio'" :value="radioItem.value" v-model="question.result">
              <label :for="question.id+'_radio_'+i" class="ml-4 mt-2">{{ radioItem.name }}</label>
            </div>
          </div>
          <div v-if="(question.result===null||question.result==='') && question.mandatory && showMandatory" class="text-red text-sm mt-2 font-bold">
            <i class="fas fa-exclamation-triangle"></i>
            required
          </div>
        </div>
      </div>
    </div>

    <!-- checkbox -->
    <div v-if="(question.type === 'checkbox' || question.type === 'follow-checkbox') && question.options && question.options.checkboxes" :class="containerClass">
      <div class="py-2 flex-grow pr-8 max-w-screen-md" v-html="question.title"></div>
      <div v-if="question.compare_last_year_flag" class="border-l border-r px-4 mr-2 justify-center items-center flex-grow">
        <span v-if="question.previous_value" class="mr-2 text-green">YES</span>
        <div v-else-if="question.previous_value!==null" :class="inputClass" class="w-full text-center">NO</div>
        <div v-else :class="inputClass" class="w-full text-center">N/A</div>
      </div>
      <div :class="columnClass">
        <checkbox-input v-model="question.result" :id="question.id+'_checkbox'" :label="question.options.checkboxes.name" :value="question.options.checkboxes.value" :class-name="inputClass" />
      </div>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import ErrorBag from '@/ErrorBag'
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  props: {
    containerClass: {
      type: String,
      default: 'flex w-full'
    },
    columnClass: {
      type: String,
      default: 'flex px-4 items-center'
    },
    inputClass: {
      type: String,
      default: 'mb-0 items-center'
    },
    value: {
      type: Object
    },
    showMandatory: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      question: this.value,
      errorBag: new ErrorBag()
    }
  },
  computed: {
    ...mapState(['annualReview'])
  },
  methods: {
    updateReviewResult: debounce(function () {
      v2Api.post(`/annual-reviews/${this.annualReview.id}/update-results`,
        { 'question_id': this.question.id, 'question_type': this.question.type, 'result': this.question.result }).then(
        response => {
        },
        errors => {
          this.errorBag.store(errors.response.data)
        }
      )
    }, 1000)
  }
}
</script>

<style scoped>
input[type="radio"] {
  display: inline-block;
  width: 50px;
  height: 20px;
}

input[type="radio"] + label {
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  position: relative;
  line-height: 1rem;
}

input[type="radio"]:checked + label::before {
  content: "";
  border-width: 0px;
}

input[type="radio"]:checked + label::before {
  background: white;
}
input[type="radio"] + label::before {
  content: '';
  display: inline-block;
  width: 0px;
  height: 0px;
  margin-right: 5px;
  border: 0px;
  padding: 0px;
  background: white;
}
</style>
